var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{staticClass:"ir-module-block",attrs:{"loading":_setup.esg.loading,"empty":_setup.isEmpty}},[_c('div',{staticClass:"esg-list"},[_c(_setup.EsgRatingList,{attrs:{"esg-data":_setup.esg.data?.data || [],"rating-config":_setup.limitedRatingConfig,"show-distribution":false}})],1),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }